export const ENV_DEV = 'development';
export const ENV_STAGING = 'staging';
export const ENV_PRODUCTION = 'production';
